// @ts-nocheck
/* eslint-disable */
import { post, get } from '../requestNew';
import {
    Message
} from '@arco-design/web-react';

export function loginPost(params?: any, callback?: any) {
    post<any>('/admin/login', params)
        .then((res: any) => {
            const { code, data, message } = res || {};
            if (code === 200) {
                callback(data)
            } else {
                Message.error(message);
            }
        })
        .catch(e => {
            Message.error('网络错误!');
            console.log(e);
        });
}

